import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "shell" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "search-form-item" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_secondary_nav = _resolveComponent("secondary-nav")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_device_icon = _resolveComponent("device-icon")
  const _component_device_status = _resolveComponent("device-status")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_autop_dialog = _resolveComponent("autop-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_secondary_nav, {
      navs: _ctx.secondMenus,
      active: _ctx.activeNavItem,
      onChoose: _ctx.changePath
    }, null, 8, ["navs", "active", "onChoose"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          class: "width400px",
          modelValue: _ctx.listRequestData.param.searchValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listRequestData.param.searchValue = $event))
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_cus_select, {
              modelValue: _ctx.listRequestData.param.searchKey,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listRequestData.param.searchKey = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchKeyList, (item) => {
                  return (_openBlock(), _createBlock(_component_cus_option, {
                    key: item,
                    value: item.name,
                    label: item.label
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_cus_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateToList++))
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
        ]),
        _: 1
      }),
      (_ctx.type==='community' && _ctx.autoP)
        ? (_openBlock(), _createBlock(_component_cus_button, {
            key: 0,
            class: "btn-right",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowAutopDialog=true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.AutoP), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_list_pagination, {
      headers: _ctx.headers,
      requestData: _ctx.listRequestData,
      update: _ctx.updateToList,
      showDefaultAction: ['info', 'delete'],
      showCheck: false,
      onInfo: _ctx.goToDeviceInfo,
      deleteUrl: "v3/web/common/device/delete"
    }, {
      TypeSlot: _withCtx((data) => [
        _createVNode(_component_device_icon, {
          class: "vertical-align-middle",
          type: Number(data.scope.Type)
        }, null, 8, ["type"])
      ]),
      StatusSlot: _withCtx((data) => [
        _createVNode(_component_device_status, {
          class: "vertical-align-middle",
          type: Number(data.scope.Status)
        }, null, 8, ["type"])
      ]),
      _: 1
    }, 8, ["headers", "requestData", "update", "onInfo"]),
    (_ctx.isShowAutopDialog)
      ? (_openBlock(), _createBlock(_component_autop_dialog, {
          key: 0,
          role: "disProject",
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowAutopDialog=false)),
          onSuccess: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateToList++))
        }))
      : _createCommentVNode("", true)
  ]))
}